// extracted by mini-css-extract-plugin
export var active = "index-module--active--33b57";
export var strip__animation = "index-module--strip__animation--1923d";
export var visible = "index-module--visible--fc608";